import Banner from "../../sections/common/banner";
import SectionServices from "../../sections/services/tax-law-services/section-services";
import { data as dataEs } from "../../../globals/data/es/derechoTributarioServices.js";
import { data as dataEn } from "../../../globals/data/en/derechoTributarioServices.js";
import { data as dataCn } from "../../../globals/data/zh/derechoTributarioServices.js";

import { useLangagesStore } from "../../../context/langages";

export default function TaxLawService() {
    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEn : language === "cn" ? dataCn : dataEs;

    return (
        <>
            <Banner _data={data.banner} />
            <SectionServices _data={data.features} />
        </>
    )
}